import { defineMessages } from "react-intl";

const ACCOUNT_CREATED_INDICATOR = "account-created-indicator";

const accountCreatedIndicatorMessages = defineMessages({
  accountCreated: {
    id: `${ACCOUNT_CREATED_INDICATOR}.account-create`,
    defaultMessage: "Account created"
  },
  signInToContinue: {
    id: `${ACCOUNT_CREATED_INDICATOR}.sign-in-to-continue`,
    defaultMessage: "Your account has been created. Please sign in to continue."
  }
});

export default accountCreatedIndicatorMessages;
